import {HttpExclude, Request} from '@simpli/serialized-request'
import {PageCollection} from '@simpli/resource-collection'
import {Category} from '@/model/resource/Category'

@HttpExclude()
export class CategoryCollection extends PageCollection<Category> {
  resource?: ICategoryCollectionResourcesHolder

  constructor() {
    super(Category)
  }

  queryAsPage() {
    return this.listCategory()
  }

  async listCategory() {
    return await Request.get(`/client/category`, {params: this.params})
      .name('listCategory')
      .as(this)
      .getResponse()
  }

  async listExportCategory() {
    return await Request.get(`/client/category/export`, {params: this.params})
      .name('listExportCategory')
      .as(this)
      .getResponse()
  }
}

export interface ICategoryCollectionResourcesHolder {}
